import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useTableSelector } from '../../redux/reduxHooks';
import { getShouldShowBulkActionsContainer } from '../../selection/redux/selectionSlice';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { TABLE_BORDER_COLOR, TABLE_HEADER_BACKGROUND_COLOR } from 'HubStyleTokens/theme';
import { TABLE_TOP_BAR_HEIGHT } from '../constants/sizes';
const TopBarContainer = styled(UIFlex).withConfig({
  displayName: "TableTopBar__TopBarContainer",
  componentId: "sc-1evy9ev-0"
})(["height:", ";flex-basis:", ";background-color:", ";border:1px solid ", ";border-bottom-width:0;"], TABLE_TOP_BAR_HEIGHT, TABLE_TOP_BAR_HEIGHT, TABLE_HEADER_BACKGROUND_COLOR, TABLE_BORDER_COLOR);

const TableTopBar = ({
  BulkActionsComponent,
  headerLeftSlot,
  headerRightSlot,
  totalRowCount
}) => {
  const shouldShowBulkActions = useTableSelector(getShouldShowBulkActionsContainer);
  return /*#__PURE__*/_jsxs(TopBarContainer, {
    className: "width-100",
    align: "center",
    justify: "start",
    children: [headerLeftSlot, shouldShowBulkActions && /*#__PURE__*/_jsx(BulkActionsContainer, {
      BulkActionsComponent: BulkActionsComponent,
      totalRowCount: totalRowCount
    }), /*#__PURE__*/_jsx("div", {
      className: "m-left-auto",
      children: headerRightSlot
    })]
  });
};

export default TableTopBar;